// Activa o desactiva el modo oscuro
export function setDark(enabled) {
  const html = document.documentElement;
  html.classList.toggle("theme-dark", !!enabled);
  html.style.colorScheme = enabled ? "dark" : "light";
}

export function applyThemeFromEnv() {
  const raw = (process.env.REACT_APP_THEME_DARK || "").trim().toLowerCase();
  const isDark = raw === "true";
  setDark(isDark);
}
